import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';
import { mainContentTabNav } from '../_app/main-content/main-content-tab-nav.css';

export const marketplaceOutletNav = style([
  mainContentTabNav,
  {
    marginBottom: space.s26,
  },
]);

export const marketplaceSearchResultContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s24,
  },
]);

export const marketplaceItemsContainer = style([
  marketplaceSearchResultContainer,
  responsiveStyle({
    mobile: {
      paddingTop: space.s4,
    },
    tablet: {
      paddingTop: space.s10,
    },
  }),
]);

export const sectionLabel = style([typography.labelLg]);
